import * as React from 'react';
import { Row, Col, Typography, Button, Table } from 'antd';
import MainLayout from './layouts/MainLayout';
import StudentsTable from '../components/StudentsTable';
import CertificateModal from '../components/CertificateModal';

const { Title } = Typography;

function StudentsScreen() {
  const [isModalVisible, setIsModalVisible] = React.useState(false);

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <MainLayout>
      <CertificateModal multiStudent visible={isModalVisible} onOk={handleOk} onCancel={handleCancel} />
      <Row>
        <Col span={12}>
          <Title level={3}>Students</Title>
        </Col>
        <Col span={12} style={{ textAlign: 'right' }}>
          <Button type="primary" onClick={showModal}>
            Assign Certificates
          </Button>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <div className="responsive-table">
            <StudentsTable />
          </div>
        </Col>
      </Row>
    </MainLayout>
  );
}

export default StudentsScreen;
